import React from 'react';
import styled from 'styled-components';
import Navbar from './Navbar';
import Footer from './Footer';
import { Palette } from 'core/config';
import { NotificationBanner } from '../common/notificationBanner';

type Props = React.HTMLAttributes<HTMLDivElement>;

export const MainLayout : React.FunctionComponent<Props> = ({ children }) =>
{
    return (
        <>
            <NotificationBanner />
            <Navbar />
            <Container>
                {children}
                {/* <Footer />  */}
            </Container>
        </>
    );
};

const Container = styled.div`
    z-index: 0;
    width : 100%;
    height: 100vh;
    background-color: ${Palette.EGGSHELL_WHITE};
    padding-left: calc(100vw - 100%);
    overflow-x: hidden;
    overflow-y: scroll;
`;